import { render, staticRenderFns } from "./activitiesTable.vue?vue&type=template&id=51f711c8&lang=pug"
import script from "./activitiesTable.vue?vue&type=script&lang=js"
export * from "./activitiesTable.vue?vue&type=script&lang=js"
import style0 from "./activitiesTable.vue?vue&type=style&index=0&id=51f711c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports